/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { productControllerCreate } from '../fn/product/product-controller-create';
import { ProductControllerCreate$Params } from '../fn/product/product-controller-create';
import { productControllerDelete } from '../fn/product/product-controller-delete';
import { ProductControllerDelete$Params } from '../fn/product/product-controller-delete';
import { productControllerGetAll } from '../fn/product/product-controller-get-all';
import { ProductControllerGetAll$Params } from '../fn/product/product-controller-get-all';
import { productControllerGetBrands } from '../fn/product/product-controller-get-brands';
import { ProductControllerGetBrands$Params } from '../fn/product/product-controller-get-brands';
import { productControllerGetOne } from '../fn/product/product-controller-get-one';
import { ProductControllerGetOne$Params } from '../fn/product/product-controller-get-one';
import { productControllerUpdate } from '../fn/product/product-controller-update';
import { ProductControllerUpdate$Params } from '../fn/product/product-controller-update';
import { ProductItem } from '../models/product-item';
import { ProductResponse } from '../models/product-response';

@Injectable({ providedIn: 'root' })
export class ProductService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `productControllerGetAll()` */
  static readonly ProductControllerGetAllPath = '/product';

  /**
   * Restituisce l'elenco dei prodotti.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productControllerGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerGetAll$Response(params: ProductControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ProductResponse;
}>> {
    return productControllerGetAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco dei prodotti.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productControllerGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerGetAll(params: ProductControllerGetAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ProductResponse;
}> {
    return this.productControllerGetAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ProductResponse;
}>): BaseResponse & {
'data'?: ProductResponse;
} => r.body)
    );
  }

  /** Path part for operation `productControllerCreate()` */
  static readonly ProductControllerCreatePath = '/product';

  /**
   * Crea un prodotto.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productControllerCreate$Response(params: ProductControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ProductItem;
}>> {
    return productControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea un prodotto.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productControllerCreate(params: ProductControllerCreate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ProductItem;
}> {
    return this.productControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ProductItem;
}>): BaseResponse & {
'data'?: ProductItem;
} => r.body)
    );
  }

  /** Path part for operation `productControllerGetBrands()` */
  static readonly ProductControllerGetBrandsPath = '/product/brands';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productControllerGetBrands()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerGetBrands$Response(params?: ProductControllerGetBrands$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: Array<string>;
}>> {
    return productControllerGetBrands(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productControllerGetBrands$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerGetBrands(params?: ProductControllerGetBrands$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: Array<string>;
}> {
    return this.productControllerGetBrands$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: Array<string>;
}>): BaseResponse & {
'data'?: Array<string>;
} => r.body)
    );
  }

  /** Path part for operation `productControllerGetOne()` */
  static readonly ProductControllerGetOnePath = '/product/{id}';

  /**
   * Restituisce un prodotto.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productControllerGetOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerGetOne$Response(params: ProductControllerGetOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ProductItem;
}>> {
    return productControllerGetOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce un prodotto.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productControllerGetOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerGetOne(params: ProductControllerGetOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ProductItem;
}> {
    return this.productControllerGetOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ProductItem;
}>): BaseResponse & {
'data'?: ProductItem;
} => r.body)
    );
  }

  /** Path part for operation `productControllerDelete()` */
  static readonly ProductControllerDeletePath = '/product/{id}';

  /**
   * Elimina un prodotto.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerDelete$Response(params: ProductControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ProductItem;
}>> {
    return productControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina un prodotto.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerDelete(params: ProductControllerDelete$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ProductItem;
}> {
    return this.productControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ProductItem;
}>): BaseResponse & {
'data'?: ProductItem;
} => r.body)
    );
  }

  /** Path part for operation `productControllerUpdate()` */
  static readonly ProductControllerUpdatePath = '/product/{id}';

  /**
   * Modifica un prodotto.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productControllerUpdate$Response(params: ProductControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ProductItem;
}>> {
    return productControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica un prodotto.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productControllerUpdate(params: ProductControllerUpdate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ProductItem;
}> {
    return this.productControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ProductItem;
}>): BaseResponse & {
'data'?: ProductItem;
} => r.body)
    );
  }

}
